<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="章节名称：">
            <el-input v-model="query.name" placeholder="请输入章节名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
            <el-button @click="handleBack" plain size="mini">返回上一页</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建章节</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="章节节数" prop="chaptersNum" align="center" />
        <el-table-column label="章节名称" prop="name" align="center" width="200" />
        <el-table-column label="封面图" prop="coverImage" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" v-if="row.coverImage" :src="row.coverImage" :preview-src-list="[row.coverImage]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="视频课" prop="videoUrl" align="center" width="200" />
        <el-table-column label="添加时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedBy" align="center" />
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <!-- REQ-2026-403009 课后考试：按视频课时各配一套题，所以入口在这一行而不是课程表单里 -->
            <el-button type="text" @click="handleAfterClassExam(row)">课后考试</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <chapter-add ref="chapterAdd" @created="doQueryList({})" :rowItem="rowItem" />
    <!-- 课后考试配置（REQ-2026-403009） -->
    <after-class-exam ref="afterClassExam" />
  </div>
</template>

<script>
import chapterAdd from './add'
import afterClassExam from '../common/afterClassExam.vue'
import courseSubjectVideoApi from '@/api/course/courseSubjectVideo'
import Pagination from '@/components/Pagination'

export default {
  props: ['rowItem'],
  components: {
    Pagination,
    chapterAdd,
    afterClassExam
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        name: undefined,
        state: undefined,
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.subjectId = this.rowItem.id
      this.listLoading = true
      return courseSubjectVideoApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => courseSubjectVideoApi.deleteBatch({ id: row.id, deleted: true }))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm(`当前选择${this.selectItems.length}条数据，是否确认删除`)
        .then(() => courseSubjectVideoApi.deleteBatch({ id: this.selectItems.map(row => row.id), deleted: true }))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      row.subjectId = this.rowItem.id
      courseSubjectVideoApi.update(row).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.chapterAdd.handleCreate(this.total)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    /** 打开该课时的课后考试配置（REQ-2026-403009） */
    handleAfterClassExam(row) {
      this.$refs.afterClassExam.open(row, this.rowItem.id)
    },
    handleUpdate(row) {
      this.$refs.chapterAdd.handleUpdate(row)
    }
  }
}
</script>
